import type { HttpPort, IInsightService, InsightChatAnswer, InsightDecision, InsightSummary, Json } from "../contracts";

// InsightService — wraps /api/insights/*. The `<decision/>` cockpit card calls
// `evaluate` after a record loads to render the deterministic decision, and
// `runAction` when the user confirms a recommended action.
export class InsightService implements IInsightService {
    constructor(private readonly http: HttpPort) {}

    async evaluate(modelKey: string, recordUuid: string): Promise<InsightDecision> {
        return this.http.post<InsightDecision>("/api/insights/evaluate", {
            model_key: modelKey,
            record_uuid: recordUuid,
            trigger: "api",
        });
    }

    async runAction(modelKey: string, recordUuid: string, actionKind: string, ref: string): Promise<Json> {
        return this.http.post<Json>("/api/insights/run-action", {
            model_key: modelKey,
            record_uuid: recordUuid,
            action_kind: actionKind,
            ref,
        });
    }

    async summarize(modelKey: string, recordUuid: string): Promise<InsightSummary> {
        return this.http.post<InsightSummary>("/api/insights/summarize", {
            model_key: modelKey,
            record_uuid: recordUuid,
        });
    }

    async chat(modelKey: string, recordUuid: string, question: string): Promise<InsightChatAnswer> {
        return this.http.post<InsightChatAnswer>("/api/insights/chat", {
            model_key: modelKey,
            record_uuid: recordUuid,
            question,
        });
    }

    async severities(
        modelKey: string,
        recordUuids: string[],
    ): Promise<Record<string, { severity: string; score: number | null }>> {
        if (recordUuids.length === 0) return {};
        return this.http.post<Record<string, { severity: string; score: number | null }>>(
            "/api/insights/severities",
            { model_key: modelKey, record_uuids: recordUuids },
        );
    }
}
